import React, { useRef } from 'react';
import { motion, useInView, useReducedMotion } from 'framer-motion';

const AnimatedSection = ({
  children,
  className = '',
  delay = 0,
  as = 'div',
  once = true,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once, margin: '-10% 0px' });
  const reduceMotion = useReducedMotion();
  const Component = motion[as] || motion.div;

  if (reduceMotion) {
    return (
      <div ref={ref} className={className}>
        {children}
      </div>
    );
  }

  return (
    <Component
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 18 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 18 }}
      transition={{ duration: 0.5, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Component>
  );
};

export default AnimatedSection;
